import React from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { CsvUploadType } from '../../../../../types/csvUploadConfiguration';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import { t } from '../../../../../types/translation/Translator';
import { Routing } from '../../../../../util/routes.util';
import { Breadcrumbs, LotOverviewCrumb, LotSettingsCrumb } from '../../../../components/Breadcrumbs';
import { Tab, Tabs } from '../../../../components/Tabs';
import CsvUploadConfigurationsScreen from '../../../../components/CsvUploadConfiguration/CsvUploadConfigurationsScreen';
import CsvUploadConfigurationUpdatePane from '../../../../components/CsvUploadConfiguration/CsvUploadConfigurationUpdatePane';
import LotTableSettingsPane from './TableSettings/LotTableSettingsPane';

export default function LotSettingsScreen() {
  const navigate = useNavigate();

  return (
    <div className='flex flex-grow flex-col'>
      <Breadcrumbs>
        <LotOverviewCrumb />
        <LotSettingsCrumb current />
      </Breadcrumbs>

      <div className='content-y-breadcrumbs flex flex-grow flex-col overflow-hidden'>
        <Tabs padding>
          <Tab
            key={'import_configurations'}
            text={t(TranslationKey.importConfigurations).singular.upper}
            path={Routing.stock.lots.settings.importConfigurations.overview()}
          />
          <Tab
            key={'table_settings'}
            text={t(TranslationKey.tableSettings).singular.upper}
            path={Routing.stock.lots.settings.tableSettings.overview()}
          />
        </Tabs>
        <div className='flex-grow overflow-hidden'>
          <Routes>
            <Route
              path={'/import_configurations/*'}
              element={
                <CsvUploadConfigurationsScreen type={CsvUploadType.lot} backPath={Routing.stock.lots.overview()} />
              }
            />
            <Route
              path={'/import_configurations/update/:id/*'}
              element={
                <CsvUploadConfigurationUpdatePane
                  type={CsvUploadType.lot}
                  onDone={() => navigate(Routing.stock.lots.settings.importConfigurations.overview())}
                />
              }
            />
            <Route path={'/table_settings/*'} element={<LotTableSettingsPane />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}
